import { Tab, Tabs } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { useFilterContext } from 'src/contexts/FilterContext';

const tabKeys = ['ownStoresTab', 'partnersTab', 'semiOwnedTab', 'wholesaleTab', 'ownEComTab'] as const;

const StoreSelectionTabs: FC = () => {
    const [filterContext, updateFilterContext] = useFilterContext();

    const activeTabIndex = tabKeys.findIndex((key) => filterContext.activeTab[key]);

    const handleChange = (_e: SyntheticEvent, newValue: number) => {
        const newActiveTab = tabKeys.reduce(
            (acc, key, index) => {
                acc[key] = index === newValue;
                return acc;
            },
            {} as Record<(typeof tabKeys)[number], boolean>
        );

        updateFilterContext({ ...filterContext, activeTab: newActiveTab });
    };

    return (
        <Tabs value={activeTabIndex} onChange={handleChange}>
            <Tab label="Own Stores" />
            <Tab label="Partner Stores" />
            <Tab label="Semi-Owned Stores" />
            <Tab label="Wholesale Stores" />
            <Tab label="Own E-Com Stores" />
        </Tabs>
    );
};

export default StoreSelectionTabs;
